import { Exercise } from "../../../../models/Exercise";
import EAAlert from "../../../shared/EAAlert";

const ReservationStatusAlerts: React.FC<{
  exercise: Exercise;
  showAllStatuses: boolean;
  t: (key: string) => string;
}> = ({ exercise, showAllStatuses, t }) => (
  <div className="purchased-assort-body__alerts">
    {exercise.deputyHumanName && <EAAlert type="warning" message={t("zastepstwo")} compact />}
    {exercise.status === "A" && <EAAlert type="success" compact message={"Zapisany"} />}
    {showAllStatuses && exercise.status === "U" && <EAAlert type="gray" compact message={"Wykorzystany"} />}
    {exercise.status === "R" && (
      <EAAlert type="warning" compact message={`Lista rezerwowa, jesteś ${exercise.waitListPosition} w kolejce`} />
    )}
  </div>
);

export default ReservationStatusAlerts;
